import './workspace.sass';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ThreeDimVisualisation from 'components/chart/three-dim/visualisation/Visualisation';

import trigger from 'actions/trigger';
import request from 'actions/request';

class Workspace extends Component {
  componentDidMount() {
    Promise.all([
      this.props.request(
        ['trackTemplate', 'get'],
        'get',
        'TRACK_TEMPLATE',
        {
          trackId: this.props.trackId,
          templateId: this.props.templateId
        }
      ),
      this.props.request(
        ['tracks', 'getInfo'],
        'get',
        'TRACK',
        { trackId: this.props.trackId }
      ),
      this.props.request(
        ['users', 'getSettings'],
        'get',
        'USER_SETTINGS',
      )
    ]).then(() => {
      let params = this.props.params || [];

      let analogParamsCodes = params
        .filter((item) => (item.type === 'ap'))
        .map((item) => item.code);

      let binaryParamsCodes = params
        .filter((item) => (item.type === 'bp'))
        .map((item) => item.code);

      this.props.trigger('chartShow', [{
        container: '#container',
        trackId: this.props.trackId,
        templateId: this.props.templateId,
        stepLength: this.props.stepLength,
        startedAt: this.props.startTrackTime,
        startFrame: this.props.fromFrame,
        endFrame: this.props.toFrame,
        apParams: analogParamsCodes,
        bpParams: binaryParamsCodes,
        threeDimIsShown: (this.props.hasCoordinates && this.props.isDisplayed)
      }]);
    });
  }

  showThreeDim() {
    if (this.props.hasCoordinates) {
      return <ThreeDimVisualisation trackId={ this.props.trackId } />;
    }

    return null;
  }

  render() {
    return (
      <div className='chart-workspace'>
        { this.showThreeDim() }
        <div id='container'></div>
      </div>
    );
  }
}

Workspace.propTypes = {
  trackId: PropTypes.number.isRequired,
  templateId: PropTypes.number.isRequired,
  fromFrame: PropTypes.number.isRequired,
  toFrame: PropTypes.number.isRequired,
  params: PropTypes.array,
  stepLength: PropTypes.number,
  startTrackTime: PropTypes.string,
  hasCoordinates: PropTypes.bool,
  isDisplayed: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    params: state.trackTemplate.params,
    stepLength: state.track.stepLength,
    startTrackTime: state.track.startTrackTime,
    startTrackTime: state.track.startTrackTime,
    settings: state.settings.items,
    hasCoordinates: state.track.hasCoordinates,
    isDisplayed: state.realtimePlayback.isDisplayed
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    trigger: bindActionCreators(trigger, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Workspace);
